import AbstractService from '@/services/abstractService'

class ContactRequestsService extends AbstractService {
    endpoint = 'contact/requests'

    index() {
      return this.http.get(this.endpoint, { params: { dashboard: true } })
    }
    //
    // post(data) {
    //   console.log('data', data)
    //   // define append form
    //   const formData = new FormData()
    //   for (const key in data) {
    //     formData.append(key, data[key])
    //   }
    //   return this.http.post(this.endpoint, formData)
    // }
    //
    // put(data) {
    //   console.log('data', data)
    //   // define append form
    //   const formData = new FormData()
    //
    //   for (const key in data) {
    //     formData.append(key, data[key])
    //   }
    //   return this.http.put(`${this.endpoint}/${data.id}`, formData)
    // }
    //
    // delete(data) {
    //   console.log('data', data)
    //   return this.http.delete(`${this.endpoint}/${data}`)
    // }
}

const Service = new ContactRequestsService()

export default Service
